import { Anchor } from '@mantine/core';

export const AnchoreResolver = Anchor.extend({
  defaultProps: {
    underline: 'never',
    inline: true,
  },
});
